// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination-module__ui-Pagination--Z3oEj {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0 8px;
}

.Pagination-module__ui-Pagination-Item--m4pba {
  box-sizing: border-box;
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--chaek-color-border-divider);
  border-radius: 14px;
  background-color: var(--chaek-color-surface-subtle);
  color: var(--chaek-color-text-secondary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.6875rem; /* 11px */
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.Pagination-module__ui-Pagination-Item--m4pba.Pagination-module__is-active--NIDEq {
  border-color: var(--chaek-color-surface-accent);
  background-color: var(--chaek-color-surface-accent);
  color: var(--chaek-color-text-inverse);
}

.Pagination-module__ui-Pagination-Item--m4pba:focus-visible {
  outline: 2px solid #1a1a1a;
  outline-offset: 2px;
}

.Pagination-module__ui-Pagination-Item--m4pba:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.Pagination-module__ui-Pagination-Ellipsis--HijRU {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 0.8125rem; /* 13px */
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,mDAAmD;EACnD,mBAAmB;EACnB,mDAAmD;EACnD,wCAAwC;EACxC,iDAAiD;EACjD,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;AAClB","sourcesContent":[".ui-Pagination {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 0 8px;\n}\n\n.ui-Pagination-Item {\n  box-sizing: border-box;\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--chaek-color-border-divider);\n  border-radius: 14px;\n  background-color: var(--chaek-color-surface-subtle);\n  color: var(--chaek-color-text-secondary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.6875rem; /* 11px */\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n}\n\n.ui-Pagination-Item.is-active {\n  border-color: var(--chaek-color-surface-accent);\n  background-color: var(--chaek-color-surface-accent);\n  color: var(--chaek-color-text-inverse);\n}\n\n.ui-Pagination-Item:focus-visible {\n  outline: 2px solid #1a1a1a;\n  outline-offset: 2px;\n}\n\n.ui-Pagination-Item:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.ui-Pagination-Ellipsis {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  color: #666;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Pagination": `Pagination-module__ui-Pagination--Z3oEj`,
	"ui-Pagination-Item": `Pagination-module__ui-Pagination-Item--m4pba`,
	"is-active": `Pagination-module__is-active--NIDEq`,
	"ui-Pagination-Ellipsis": `Pagination-module__ui-Pagination-Ellipsis--HijRU`
};
export default ___CSS_LOADER_EXPORT___;
